// extracted by mini-css-extract-plugin
export default {"footer":"MainNavigation_footer__Sg1XL","menuItem":"MainNavigation_menuItem__P1+yz","menuItemTitle":"MainNavigation_menuItemTitle__0ASon","selected":"MainNavigation_selected__OPmH3"};